import {Box, css, Link, List, ListItem, styled, Typography} from '@mui/material';
import {CardInstructionsVariantEnum, StyledCardInstructionsTypes} from './types';

const StyledBox = styled(Box)<StyledCardInstructionsTypes>`
	display: flex;
	flex-direction: column;
	gap: 24px;
	background-color: ${({theme}) => theme.palette.background.paper};
	width: 100%;
	padding: 24px;
	border-radius: 8px;

	${({$variant}) =>
		$variant === CardInstructionsVariantEnum.SMALL
			? css`
					gap: 16px;
				`
			: null}
`;

const StyledHeader = styled(Box)<StyledCardInstructionsTypes>`
	display: flex;
	flex-direction: column;
	gap: 24px;
	width: 100%;

	${({$variant}) =>
		$variant === CardInstructionsVariantEnum.SMALL
			? css`
					gap: 8px;
				`
			: null}
`;

const StyledTitle = styled(Typography)<StyledCardInstructionsTypes>`
	font-size: 1.25rem;
	font-weight: 600;
	letter-spacing: auto;
	color: ${({theme}) => theme.palette.text.primary};
	text-align: center;

	${({$variant}) =>
		$variant === CardInstructionsVariantEnum.SMALL
			? css`
					font-size: 1rem;
					letter-spacing: 0.15px;
					text-align: left;
				`
			: null}
`;

const StyledDescription = styled(Typography)<StyledCardInstructionsTypes>`
	font-size: 1rem;
	font-weight: 600;
	color: ${({theme}) => theme.palette.text.secondary};

	${({$variant}) =>
		$variant === CardInstructionsVariantEnum.SMALL
			? css`
					font-size: 0.875rem;
				`
			: null}
`;

const StyledItemDescription = styled(Typography)<StyledCardInstructionsTypes>`
	font-size: 1rem;
	font-weight: 400;
	color: ${({theme}) => theme.palette.text.primary};

	${({$variant}) =>
		$variant === CardInstructionsVariantEnum.SMALL
			? css`
					font-size: 0.875rem;
				`
			: null}
`;
const StyledLink = styled(Link)<StyledCardInstructionsTypes>`
	font-size: 1rem;
	color: ${({theme}) => theme.palette.primary.main};
	cursor: pointer;

	${({$variant}) =>
		$variant === CardInstructionsVariantEnum.SMALL
			? css`
					font-size: 0.875rem;
				`
			: null}
`;

const StyledList = styled(List)`
	list-style: disc;
	padding: 8px 16px;
`;

const StyledListItem = styled(ListItem)<StyledCardInstructionsTypes>`
	display: list-item;
	list-style-type: inherit;
	color: ${({theme}) => theme.palette.text.primary};
	padding: 2px 0;

	${({$variant}) =>
		$variant === CardInstructionsVariantEnum.SMALL
			? css`
					font-size: 0.875rem;
				`
			: null}
`;

export {
	StyledBox,
	StyledHeader,
	StyledList,
	StyledListItem,
	StyledTitle,
	StyledDescription,
	StyledItemDescription,
	StyledLink,
};
